import React, { useState, useEffect } from 'react';
import noImage from '../../assets/images/no-image.png';
import { getPreReadSignedWriteUrl } from '../../services/s3Services';

export default function S3Image({ s3Key, className, alt, width }) {
  const [src, setSrc] = useState(noImage);

  useEffect(() => {
    if (!s3Key) {
      setSrc(noImage);
      return;
    }

    /* Values that are already renderable are shown as-is: absolute URLs, base64 data URIs (a
       freshly cropped image not yet uploaded), and bundled/root-relative assets such as the
       noImage placeholder. Only a bare S3 object key needs presigning. */
    if (/^(https?:\/\/|data:|blob:|\/)/.test(s3Key)) {
      setSrc(s3Key);
      return;
    }

    let cancelled = false;
    getPreReadSignedWriteUrl({ objectKey: s3Key })
      .then((res) => {
        if (!cancelled && res?.code === 200 && res?.data) {
          setSrc(res.data);
        }
      })
      .catch(() => {
        if (!cancelled) setSrc(noImage);
      });
    return () => {
      cancelled = true;
    };
  }, [s3Key]);

  return (
    <img
      className={className || 'logo max-w-h-48'}
      src={src}
      width={width}
      alt={alt || 'Product'}
      onError={(e) => {
        e.target.src = noImage;
      }}
    />
  );
}
